// @flow
import React from 'react';

import LoaderImg from 'assets/images/loader.svg';

import MiniLoader from 'components/shared/MiniLoader/MiniLoader';

type Props = {
  loading: boolean,
    ...
}

export default (Component: any) => (props: Props) => (
  <>
    {props.loading && (
      <MiniLoader show />
    )}
    {props.loading === false
      && <Component {...props} />}
  </>
);
